export const onlinePkStatsOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  column: [
    {
      label: '总经理',
      prop: 'name',
      editDisabled: true,
    },
    {
      label: 'Patch阶段总人数',
      prop: 'patchTotalCount',
      editDisabled: true,
    },
    {
      label: 'Patch阶段参赛总人数',
      prop: 'patchTotalMemberCount',
      editDisabled: true,
    },
    {
      label: 'Patch阶段平均积分',
      prop: 'patchPkAvgScore',
      editDisabled: true,
    },
    {
      label: 'Patch阶段PK总次数',
      prop: 'patchPkCount',
      editDisabled: true,
    },
    {
      label: 'Patch阶段PK平均答题时间/次',
      prop: 'patchAvgTime',
      editDisabled: true,
    },
    {
      label: 'Patch阶段累计答题总数',
      prop: 'patchSubjectCount',
      editDisabled: true,
    },
    {
      label: 'Patch阶段累计答题正确数',
      prop: 'patchSubjectCorrectCount',
      editDisabled: true,
    },    {
      label: 'Patch阶段答题正确率',
      prop: 'patchSubjectVictoryRate',
      editDisabled: true,
    },
    {
      label: 'PC阶段总人数',
      prop: 'pcTotalCount',
      editDisabled: true,
    },
    {
      label: 'PC阶段参赛总人数',
      prop: 'pcTotalMemberCount',
      editDisabled: true,
    },
    {
      label: 'PC阶段平均积分',
      prop: 'pcPkAvgScore',
      editDisabled: true,
    },
    {
      label: 'PC阶段PK总次数',
      prop: 'pcPkCount',
      editDisabled: true,
    },
    {
      label: 'PC阶段PK平均答题时间/次',
      prop: 'pcAvgTime',
      editDisabled: true,
    },
    {
      label: 'PC阶段累计答题总数',
      prop: 'pcSubjectCount',
      editDisabled: true,
    },
    {
      label: 'PC阶段累计答题正确数',
      prop: 'pcSubjectCorrectCount',
      editDisabled: true,
    },
    {
      label: 'PC阶段答题正确率',
      prop: 'pcSubjectVictoryRate',
      editDisabled: true,
    },
    {
      label: 'DO阶段总人数',
      prop: 'doTotalCount',
      editDisabled: true,
    },
    {
      label: 'DO阶段参赛总人数',
      prop: 'doTotalMemberCount',
      editDisabled: true,
    },
    {
      label: 'DO阶段平均积分',
      prop: 'doPkAvgScore',
      editDisabled: true,
    },
    {
      label: 'DO阶段PK总次数',
      prop: 'doPkCount',
      editDisabled: true,
    },
    {
      label: 'DO阶段PK平均答题时间/次',
      prop: 'doAvgTime',
      editDisabled: true,
    },
    {
      label: 'DO阶段累计答题总数',
      prop: 'doSubjectCount',
      editDisabled: true,
    },
    {
      label: 'DO阶段累计答题正确数',
      prop: 'doSubjectCorrectCount',
      editDisabled: true,
    },
    {
      label: 'DO阶段答题正确率',
      prop: 'doSubjectVictoryRate',
      editDisabled: true,
    },
  ]
}

export const onlinePkStageOptions = [
  { label: 'Patch阶段', value: 'PK_PATCH' },
  { label: 'PC阶段', value: 'PK_PC' },
  { label: 'DO阶段', value: 'PK_DO' },
]